import { defineStyleConfig } from '@chakra-ui/system';

const baseStyle = {
    bg: 'var(--tooltip-bg)',
    '--popper-arrow-bg': 'var(--tooltip-bg)',
    maxW: { base: '220px', sm: '280px' },
    '--tooltip-bg': 'white',
    color: 'slt-black.900',
    fontFamily: 'brandon-grotesque',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    letterSpacing: '0.25px',
    padding: 2,
    borderRadius: '2px',
    filter: 'drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1))',
    marginTop: 1,
    marginBottom: 2,
};

export const Tooltip = defineStyleConfig({
    baseStyle,
    variants: {
        'new-style': {
            ...baseStyle,
            borderRadius: '4px',
            fontFamily: 'TT Norms Pro',
            minWidth: '255px',
        },
    },
});
